<template>
  <div class="hy-piao_num">
    <div class="title">
      <h5>开具发票份数设置</h5>
    </div>
    <div class="typelist">
      <div class="Myunmber">
        <p>发票总额</p>
        <p class="num">
          <b>{{checkbox.allAmount}}</b>元
        </p>
      </div>
      <div class="fenbox">
        <span>发票总数<i>{{typelist.length}}</i>份</span>
        <el-button type="primary" size="mini" style="margin-left:10px;" @click="addNum">增加发票</el-button>
      </div>
      <!-- 循环字段-->
      <div class="input_box" v-for="(items,index) in typelist" :key="index">
        <!-- 文本输入框-->
        {{'发票金额 '+(index+1)}}
        <el-input   v-model="typelist[index].num"  placeholder="输入金额"   type="number" @blur="onBlur(index)">
          <el-button slot="append"  @click="remove(index)">移除</el-button>
            </el-input>


      </div>
    </div>
    <div class="addPiaoBtnbox">
      <el-button type="primary" @click="addPiaoBtn">确认设置</el-button>
    </div>
  </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        typelist: [{
          num: '',
          btn: false,
        }, ],
        checkbox: {},
      };
    },
    created: function() {
      var _this = this;
      var local = JSON.parse(localStorage.getItem('invoiceMenu'));
      _this.checkbox = local;
      var piao_data = JSON.parse(localStorage.getItem('piao_data'));
      if (piao_data) {
        _this.typelist = piao_data;
      }
    },
    methods: {
      onBlur(i) {
        // 过滤输入的数字
        var _this = this;
        var num = Number(_this.typelist[i].num);
        _this.typelist[i].num = num.toFixed(2);
      },
      remove(i) {
        var _this = this;
        _this.typelist.splice(i, 1);
      },
      addNum() {
        var _this = this;
        _this.typelist.push({
          num: '',
          btn: true,
        });
      },
      //提交开票信息
      addPiaoBtn() {
        var _this = this;
        var nums = 0;
        if(_this.typelist.length < 1){
          _this.$message({
            showClose: true,
            message: '发票份数不能为 0',
            type: 'error'
          });
          return false;
        }
        for (var i = 0; i < _this.typelist.length; i++) {
          if (_this.typelist[i].num == '') {
            _this.$message({
              showClose: true,
              message: '请输入发票 ' + (i + 1) + ' 金额',
              type: 'error'
            });
            return false;
          } else if (_this.typelist[i].num == '0.00') {
            _this.$message({
              showClose: true,
              message: '发票金额不能为 0',
              type: 'error'
            });
            return false;
          } else {
            nums += parseFloat(_this.typelist[i].num)
          }
        }
        if (nums != _this.checkbox.allAmount) {
          _this.$message({
            showClose: true,
            message: '开票总金额不等于可开发票金额！ ',
            type: 'error'
          });
        } else if (nums < _this.checkbox.allAmount) {

         /* _this.$confirm('当前发票金额小于发票总额，是否确认继续？', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // on confirm
            localStorage.setItem('piao_data', JSON.stringify(_this.typelist));
            _this.$emit('openInvoiceNumDialog',2);

          }).catch(() => {

          }); */
        } else {
          localStorage.setItem('piao_data', JSON.stringify(_this.typelist));
          _this.$emit('openInvoiceNumDialog',2);
        }

      }
    },
    mounted() {}
  }
</script>
<style  >
  .hy-piao_num .typelist {
    width: 100%;
    height: 100%;
    background: #FFF;
  }
  .hy-piao_num .typelist .fenbox {
    line-height: 50px;
    border: 10px solid #f7f7f7;
    border-left: none;
    border-right: none;
    padding: 0 12.5px;
    overflow: hidden;
  }
  .hy-piao_num .typelist .fenbox span {
    font-size: 14px;
  }
  .hy-piao_num .typelist .fenbox span i {
    color: #ee0a24;
    padding: 0 5px;
    display: inline-block;
    font-style: inherit;
  }
  .hy-piao_num .typelist .fenbox .van-button {
    float: right;
    height: 30px;
    margin: 10px 0px;
    font-size: 12px;
  }
  .hy-piao_num .typelist .fenbox .van-button .van-button__text {
    font-size: 12px;
  }
  .hy-piao_num .typelist .Myunmber {
    width: 100%;
    padding: 15px;
    border-bottom: 0.5px solid #ebebeb;
  }
  .hy-piao_num .typelist .Myunmber p {
    font-size: 12px;
    text-align: center;
  }
  .hy-piao_num .typelist .Myunmber .num {
    font-size: 12px;
    text-align: center;
    line-height: 40px;
  }
  .hy-piao_num .typelist .Myunmber .num b {
    font-size: 22.5px;
    color: #ee0a24;
    padding: 0 5px;
  }
  .hy-piao_num .input_box{
   line-height: 50px;
    padding: 10px 0px 0px;
  }
  .hy-piao_num .el-input{
    width: 70%;
    margin-left: 10px;
  }
  .hy-piao_num .addPiaoBtnbox{
    text-align: center;
  }
  .hy-piao_num .addPiaoBtnbox .el-button{
    margin:  20px auto 0px;
  }

</style>
